<template>
  <v-container class="px-0 mx-0 text-center">
    <v-progress-linear indeterminate :active="loading"></v-progress-linear>

    <span class="grey--text darken-1" v-if="!loading && schedules <= 0">
      Nenhuma consulta agendada
    </span>

    <v-row dense>
      <v-col v-for="(schedule, i) in schedules" :key="schedule.id"
        xl="4" lg="6" md="6" sm="12" cols="12">
        <my-schedule-card v-model="schedules[i]" v-if="i < 4"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';
import MyScheduleCard from '@/components/mySchedules/MyScheduleCard';

export default {
  data: () => ({
    loading: false,
    schedules: [],
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
  },
  mounted() {
    this.getNextEvents();
  },
  methods: {
    getNextEvents() {
      this.loading = true;
      if (this.user && this.isAuthenticated) {
        this.$store
          .dispatch('patientSchedules/getNexts', this.user.id)
          .then((schedules) => {
            this.schedules = schedules;
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  components: {
    MyScheduleCard,
  },
};
</script>
